import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { _Object } from 'utils/interfaces';
import { orderService } from 'services';
import { doAmountFormat } from 'utils';

interface Props {
  modal: boolean;
  setModal: (val: boolean) => void;
  modalId?: string;
}

const TodaySalesSummary = ({ modal, setModal, modalId = 'todaySummaryModal' }: Props) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<_Object>({
    search: false,
    summary: false,
    discountbtn: false
  });

  const [orderSummary, setOrderSummary] = useState<_Object>({});

  useEffect(() => {
    if (modal) {
      setLoading({ summary: true });
      orderService.getOrderSummary({
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD')
      }).then((data: _Object) => {
        setOrderSummary(data);
        setLoading({ summary: false });
      });
    }
  }, [modal]);

  return (
    <div
      className="summary-icons modal fade"
      id={modalId}
      tabIndex={-1}
      aria-labelledby={`${modalId}Label`}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="mb-0" id={`${modalId}Label`}>
              {t('checkout.sales_summary')}
            </h4>
            <button
              type="button"
              onClick={() => setModal(false)}
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>

          <div className="modal-body">
            <div className="d-flex align-items-center date-header border-bottom">
              <aside><h4 className="mb-0">{moment().format('DD')}</h4></aside>
              {moment().format('MMM').toUpperCase()} <br />
              {moment().format('YYYY')}
              <p className="mb-0">{moment().format('dddd').toUpperCase()}</p>
            </div>

            <ul className={`list-inline mb-0 ${modal === true && loading.summary === true ? 'is-loading' : ''}`}>
              <li className="list-inline-item">
                <h6>{t('common.sales')}</h6>
                <span>{orderSummary?.sales?.total ? doAmountFormat(orderSummary?.sales?.total) : '-'}</span>
              </li>
              <li className="list-inline-item">
                <h6>{t('common.expense')}</h6>
                <span>{orderSummary?.expense?.total ? doAmountFormat(orderSummary?.expense?.total) : '-'}</span>
              </li>
              <li className="list-inline-item">
                <h6><strong>{t('common.total')}</strong></h6>
                <span>
                  <strong>
                    {orderSummary?.sales?.total
                      ? doAmountFormat(orderSummary?.sales?.total - orderSummary?.expense?.total)
                      : '-'}
                  </strong>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodaySalesSummary;